// dev bmw

export const environment = {
  production: false,
  tapLifetimeInHoursSelfService: 2,
  tapLifetimeInHours: 24,
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-113033}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Bayerische_Motoren_Werke_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BOB_-_BMW_Onboarding_Buddy}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BOB_-_BMW_Onboarding_Buddy}_need_to_be_licensed___{BOB_-_BMW_Onboarding_Buddy}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_November_2026}____[v3]_[01]_MTc5NTczNzYwMDAwMA==49b13d4fdffef011c68313917b2bea74',
  msalConfig: {
    clientId: 'fa1b136c-d52c-4f5e-a51b-4c4d26e1d666',
    authority:
      'https://login.microsoftonline.com/ce849bab-cc1c-465b-b62e-18f07c9ac198',
    redirectUri: 'https://bob-d.azure.bmw.cloud',
    // redirectUri: 'http://localhost:4200/',
    env: 'dev',
  },
  // pollingBase: 'http://localhost:7071/api/status/',
  pollingBase: '/api/status/',
  graphApi: {
    userEndpoint: 'https://graph.microsoft.com/v1.0/me',
    groupsEndpoint: 'https://graph.microsoft.com/v1.0/me/memberOf',
    groupMembersEndpoint:
      'https://graph.microsoft.com/v1.0/groups/74f55f51-5fc5-42da-bf70-d62434c0e683/members',
  },
  azureFunction: {
    // orchestratorAEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_A',
    // orchestratorBEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_B',
    // orchestratorCEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_C',
    // orchestratorDEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_D',
    // orchestratorEEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_E',
    // orchestratorFEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_F',
    // orchestratorGEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_G',
    // orchestratorHEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_H',
    // orchestratorIEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_I',
    // orchestratorJEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_J',
    // orchestratorKEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_K',
    // orchestratorLEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_L',
    // orchestratorMEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_M',
    // orchestratorNEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_N',
    // orchestratorOEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_O',
    // orchestratorPEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_P',
    // orchestratorQEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_Q',
    // orchestratorREndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_R',
    // orchestratorSEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_S',
    // orchestratorTEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_T',
    // orchestratorUEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_U',
    // orchestratorVEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_V',
    // orchestratorWEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_W',
    // orchestratorXEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_X',
    // orchestratorYEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_Y',
    // orchestratorZEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_Z',
    // orchestratorAAEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_AA',
    // orchestratorBBEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_BB',
    // orchestratorCCEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_CC',
    // orchestratorDDEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_DD',
    // orchestratorEEEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_EE',
    // orchestratorFFEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_FF',
    // orchestratorGGEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_GG',
    // orchestratorHHEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_HH',
    // orchestratorIIEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_II',
    // orchestratorJJEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_JJ',
    // orchestratorKKEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_KK',
    // orchestratorLLEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_LL',
    // orchestratorMMEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_MM',
    // orchestratorNNEndpoint:
    //   'http://localhost:7071/api/orchestrators/Orchestrator_NN',
    orchestratorAEndpoint: '/api/orchestrators/Orchestrator_A',
    orchestratorBEndpoint: '/api/orchestrators/Orchestrator_B',
    orchestratorCEndpoint: '/api/orchestrators/Orchestrator_C',
    orchestratorDEndpoint: '/api/orchestrators/Orchestrator_D',
    orchestratorEEndpoint: '/api/orchestrators/Orchestrator_E',
    orchestratorFEndpoint: '/api/orchestrators/Orchestrator_F',
    orchestratorGEndpoint: '/api/orchestrators/Orchestrator_G',
    orchestratorHEndpoint: '/api/orchestrators/Orchestrator_H',
    orchestratorIEndpoint: '/api/orchestrators/Orchestrator_I',
    orchestratorJEndpoint: '/api/orchestrators/Orchestrator_J',
    orchestratorKEndpoint: '/api/orchestrators/Orchestrator_K',
    orchestratorLEndpoint: '/api/orchestrators/Orchestrator_L',
    orchestratorMEndpoint: '/api/orchestrators/Orchestrator_M',
    orchestratorNEndpoint: '/api/orchestrators/Orchestrator_N',
    orchestratorOEndpoint: '/api/orchestrators/Orchestrator_O',
    orchestratorPEndpoint: '/api/orchestrators/Orchestrator_P',
    orchestratorQEndpoint: '/api/orchestrators/Orchestrator_Q',
    orchestratorREndpoint: '/api/orchestrators/Orchestrator_R',
    orchestratorSEndpoint: '/api/orchestrators/Orchestrator_S',
    orchestratorTEndpoint: '/api/orchestrators/Orchestrator_T',
    orchestratorUEndpoint: '/api/orchestrators/Orchestrator_U',
    orchestratorVEndpoint: '/api/orchestrators/Orchestrator_V',
    orchestratorWEndpoint: '/api/orchestrators/Orchestrator_W',
    orchestratorXEndpoint: '/api/orchestrators/Orchestrator_X',
    orchestratorYEndpoint: '/api/orchestrators/Orchestrator_Y',
    orchestratorZEndpoint: '/api/orchestrators/Orchestrator_Z',
    orchestratorAAEndpoint: '/api/orchestrators/Orchestrator_AA',
    orchestratorBBEndpoint: '/api/orchestrators/Orchestrator_BB',
    orchestratorCCEndpoint: '/api/orchestrators/Orchestrator_CC',
    orchestratorDDEndpoint: '/api/orchestrators/Orchestrator_DD',
    orchestratorEEEndpoint: '/api/orchestrators/Orchestrator_EE',
    orchestratorFFEndpoint: '/api/orchestrators/Orchestrator_FF',
    orchestratorGGEndpoint: '/api/orchestrators/Orchestrator_GG',
    orchestratorHHEndpoint: '/api/orchestrators/Orchestrator_HH',
    orchestratorIIEndpoint: '/api/orchestrators/Orchestrator_II',
    orchestratorJJEndpoint: '/api/orchestrators/Orchestrator_JJ',
    orchestratorKKEndpoint: '/api/orchestrators/Orchestrator_KK',
    orchestratorLLEndpoint: '/api/orchestrators/Orchestrator_LL',
    orchestratorMMEndpoint: '/api/orchestrators/Orchestrator_MM',
    orchestratorNNEndpoint: '/api/orchestrators/Orchestrator_NN',
  },
  groupConfig: {
    kioskGroups: ['178ef2ee-98f2-4ccd-86ae-6e1f2e7008d6'],
    kioskTargetGroups: ['338df7dd-0d45-40fa-b687-f50ade7c2793'],
    meisterGroups: ['d1058574-135f-4993-b14e-cee110c1ea07'],
  },
  errorMessages: {
    de: 'Ein Fehler ist aufgetreten. Bitte versuche es in ein paar Minuten nochmal oder melde dich bei Lars.Thaesler@partner.bmw.de',
    en: 'An error has occured. Please try again in a few minutes or contact Lars.Thaesler@partner.bmw.de',
  },
};
